import RouteTemplate from "ember-route-template";
import ProxyviewsCompare from "../components/proxyviews-compare";

export default RouteTemplate(
  <template><ProxyviewsCompare @providers={{@model.providers}} /></template>
);
